import { ReactNode, useEffect } from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';

import { useGetUserMe } from '@/api/REST/userMe';
import { useLocaleStore } from '@/stores/locale';

export const LocalizationSetup = ({ children }: { children: ReactNode }) => {
  const { locale: currentLocale, setLang } = useLocaleStore();

  const { data: userMeData, isLoading: isUserMeDataLoading } = useGetUserMe();

  useEffect(() => {
    if (userMeData?.language && !isUserMeDataLoading) {
      setLang(userMeData.language.locale ?? 'en');
    } else {
      setLang('en');
    }
  }, [isUserMeDataLoading]);

  return (
    <LocalizationProvider
      adapterLocale={currentLocale.dateFn}
      dateAdapter={AdapterDateFns}
    >
      {children}
    </LocalizationProvider>
  );
};
